var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { DEFAULT_SNAP_ID, addAddressToBook, deleteAddressFromBook, deleteChain, getAccountInfo, getAddressBook, getBech32Address, getBech32Addresses, getChains, getKey, installSnap, sendTx, sign, signAmino, signAndBroadcast, signDirect, suggestChain } from './snap.js';
import { CosmJSOfflineSigner } from './signer.js';
export class CosmosSnap {
    constructor() {
        this.snap_id = DEFAULT_SNAP_ID;
    }
    changeSnapId(snap_id) {
        this.snap_id = snap_id;
    }
    getAccount(chain_id) {
        return __awaiter(this, void 0, void 0, function* () {
            let account = yield getAccountInfo(chain_id, this.snap_id);
            return account;
        });
    }
    getKey(chain_id) {
        return __awaiter(this, void 0, void 0, function* () {
            let key = yield getKey(chain_id, this.snap_id);
            return key;
        });
    }
    deleteChain(chain_id) {
        return __awaiter(this, void 0, void 0, function* () {
            yield deleteChain(chain_id, this.snap_id);
        });
    }
    signAndBroadcast(chain_id, msgs, fees) {
        return __awaiter(this, void 0, void 0, function* () {
            let res = yield signAndBroadcast(chain_id, msgs, fees, this.snap_id);
            return res;
        });
    }
    sign(chain_id, msgs, fees) {
        return __awaiter(this, void 0, void 0, function* () {
            let res = sign(chain_id, msgs, fees, this.snap_id);
            return res;
        });
    }
    addAddressToBook(chain_id, address, name) {
        return __awaiter(this, void 0, void 0, function* () {
            yield addAddressToBook(chain_id, address, name, this.snap_id);
        });
    }
    getAddressBook() {
        return __awaiter(this, void 0, void 0, function* () {
            let addresses = yield getAddressBook(this.snap_id);
            return addresses;
        });
    }
    deleteAddressFromBook(address) {
        return __awaiter(this, void 0, void 0, function* () {
            yield deleteAddressFromBook(address, this.snap_id);
        });
    }
    getBech32Addresses() {
        return __awaiter(this, void 0, void 0, function* () {
            let addresses = getBech32Addresses(this.snap_id);
            return addresses;
        });
    }
    getBech32Address(chain_id) {
        return __awaiter(this, void 0, void 0, function* () {
            let address = getBech32Address(chain_id, this.snap_id);
            return address;
        });
    }
    enable() {
        return __awaiter(this, void 0, void 0, function* () {
            yield installSnap(this.snap_id);
            return true;
        });
    }
    getChains() {
        return __awaiter(this, void 0, void 0, function* () {
            let chains = yield getChains(this.snap_id);
            return chains;
        });
    }
    experimentalSuggestChain(chainInfo) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            let chains = yield this.getChains();
            let chainIds = chains.map(item => item.chain_id);
            if (chainIds.includes(chainInfo.chainId)) {
                return true;
            }
            let chain = {
                pretty_name: chainInfo.chainName,
                chain_name: chainInfo.chainName,
                chain_id: chainInfo.chainId,
                slip44: chainInfo.bip44.coinType,
                bech32_prefix: chainInfo.bech32Config.bech32PrefixAccAddr,
                fees: {
                    fee_tokens: chainInfo.feeCurrencies.map(item => {
                        return {
                            denom: item.coinDenom,
                            low_gas_price: item.gasPriceStep.low,
                            average_gas_price: item.gasPriceStep.high,
                            high_gas_price: item.gasPriceStep.high,
                        };
                    })
                },
                staking: {
                    staking_tokens: [
                        { denom: chainInfo.stakeCurrency.coinDenom }
                    ]
                },
                logo_URIs: {
                    png: (_a = chainInfo.chainSymbolImageUrl) !== null && _a !== void 0 ? _a : undefined,
                    svg: (_b = chainInfo.chainSymbolImageUrl) !== null && _b !== void 0 ? _b : undefined
                },
                apis: {
                    rpc: [
                        {
                            address: chainInfo.rpc,
                        }
                    ],
                    rest: [
                        {
                            address: chainInfo.rest,
                        }
                    ]
                },
                address: undefined
            };
            yield suggestChain(chain, this.snap_id);
            return true;
        });
    }
    signAmino(chainId, signer, signDoc) {
        return __awaiter(this, void 0, void 0, function* () {
            let res = yield signAmino(chainId, signer, signDoc, this.snap_id);
            return res;
        });
    }
    signDirect(chainId, signer, signDoc) {
        return __awaiter(this, void 0, void 0, function* () {
            let res = yield signDirect(chainId, signer, signDoc, this.snap_id);
            return res;
        });
    }
    sendTx(chainId, tx) {
        return __awaiter(this, void 0, void 0, function* () {
            let res = yield sendTx(chainId, tx, this.snap_id);
            return res;
        });
    }
    getOfflineSigner(chainId) {
        return new CosmJSOfflineSigner(chainId, this.snap_id);
    }
}
//# sourceMappingURL=provider.js.map